import { trans } from "@mongez/localization";
import { isEmpty } from "@mongez/supportive-is";
import { productAtom } from "core/catalog";
import patternImg from "~/assets/images/pattern.png";
import { NotFoundPage } from "~/modules/informative-pages/pages";
import { HTML } from "~/modules/shared/components";
import {
  ProductDetailsBreadcrumb,
  ProductDetailsData,
  ProductDetailsImages,
  RelatedProducts,
  SimilarProducts,
} from "../components";

export function ProductDetailsPage() {
  const product = productAtom.use("product");

  if (isEmpty(product)) {
    return <NotFoundPage />;
  }

  return (
    <section className="relative overflow-hidden bg-white/60">
      <img
        src={patternImg}
        alt="background pattern"
        className="absolute top-0 left-0 h-full w-full bg-neutral-50 object-cover object-center opacity-50"
      />
      <div className="relative z-20 container py-4 lg:py-6">
        <ProductDetailsBreadcrumb />
        <div className="grid grid-cols-1 gap-12 2xl:grid-cols-2">
          <ProductDetailsImages />
          <ProductDetailsData />
        </div>
      </div>
      {product.description && (
        <div className="relative container bg-white pt-4 lg:pt-6">
          <h2 className="border-border border-b pb-2 text-2xl font-bold lg:pb-4 lg:text-3xl">
            {trans("description")}
          </h2>
          <HTML
            html={product.description}
            className="prose max-w-none py-6 text-black/90"
          />
        </div>
      )}
      <div className="relative flex flex-col">
        <RelatedProducts productId={product.id} />
        <SimilarProducts productId={product.id} />
      </div>
    </section>
  );
}
